import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=bbe57562&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=bbe57562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe57562",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbe57562')) {
      api.createRecord('bbe57562', component.options)
    } else {
      api.reload('bbe57562', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=bbe57562&scoped=true&", function () {
      api.rerender('bbe57562', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-299z7wGPT8D3m/JS/comp/GuestBox.vue"
export default component.exports